/**
 * Hibaüzenetek - API és rendszer hibák
 *
 * Namespace: errors
 */
export const errors = {
  // Hálózati hibák
  network: "Nem sikerült kapcsolódni a szerverhez. Kérjük, ellenőrizd az internetkapcsolatod.",
  timeout: "A kérés időtúllépés miatt megszakadt. Kérjük, próbáld újra.",

  // HTTP státusz hibák
  serverError: "Szerverhiba történt. Kérjük, próbáld újra később.",
  unauthorized: "Nincs jogosultságod ehhez a művelethez. Kérjük, jelentkezz be újra.",
  forbidden: "Hozzáférés megtagadva.",
  notFound: "A keresett erőforrás nem található.",
  validation: "Érvénytelen adatok. Kérjük, ellenőrizd a megadott adatokat.",
  conflict: "A művelet nem hajtható végre. Az erőforrás már létezik.",

  // Általános
  default: "Váratlan hiba történt. Kérjük, próbáld újra.",
} as const;

export type ErrorMessages = typeof errors;
